import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaInstagram,
  FaTiktok,
  FaFacebook,
  FaYoutube,
} from "react-icons/fa";
import "./../styles/Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="tapsi-header">
      <button
        type="button"
        className="header-menu-button"
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
        aria-controls="header-navigation"
        onClick={() => setMenuOpen((open) => !open)}
      >
        {menuOpen ? <FaTimes aria-hidden="true" /> : <FaBars aria-hidden="true" />}
        <span className="header-menu-label">Menu</span>
      </button>

      <div className="logo">
        <Link to="/" className="logo-link" onClick={() => setMenuOpen(false)}>
          <img src="/logotapsi.png" alt="Tapsi Logo" className="logo-img" />
          <h1>tapsiwr.gr</h1>
        </Link>
      </div>

      <div className="header-actions">
        <div className="header-social-links" aria-label="Social media">
          <a
            href="https://www.instagram.com/tapsi.wr/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram aria-hidden="true" />
          </a>
          <a
            href="https://www.tiktok.com/@tapsi.wr?is_from_webapp=1&sender_device=pc"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
          >
            <FaTiktok aria-hidden="true" />
          </a>
          <a
            href="https://www.facebook.com/groups/2071430503389722/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebook aria-hidden="true" />
          </a>
          <a
            href="https://www.youtube.com/@%CE%A4%CE%91%CE%A8%CE%99/videos"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <FaYoutube aria-hidden="true" />
          </a>
        </div>
      </div>

      <nav
        id="header-navigation"
        className={menuOpen ? "header-nav is-open" : "header-nav"}
        aria-label="Main navigation"
      >
        <ul className="nav-list">
          <li>
            <NavLink
              to="/schedule"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setMenuOpen(false)}
            >
              Schedule
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/podcasts"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setMenuOpen(false)}
            >
              Podcasts
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/mini-games"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setMenuOpen(false)}
            >
              Games
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about-us"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setMenuOpen(false)}
            >
              About us
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}